import { IReelParameters } from '@GFTypes/GameStoreTypes/ReelParameters';

export const REEL_PARAMETERS_DEFAULTS: IReelParameters = {
    prevHeight: 267 * 3,
    prevWidth: 300,
    height: 267 * 3,
    width: 300,
    reelCenters: [],
    reelsSpineScale: 1,
    scalesPerReel: [],
    defaultSymbolLocalPositions: [],
    defaultSymbolContainerPositions: [],
    uiMarker: undefined
};
